import './style.css';

export const Spinner = ({ visible, solid = false }) => {
    return (
        <div id="loading-spinner" className={( visible ? '' : 'hidden' ) + ' ' + ( solid ? 'solid' : '' )} ></div>
    )
};